// 保证mutation的唯一性
export const SET_EMAIL = 'SET_EMAIL' // email保存

export const SET_URL = 'SET_URL'



// WEBPACK FOOTER //
// ./src/store/mutation_types.js